import { render, staticRenderFns } from "./MembersAreaNew.vue?vue&type=template&id=24af3658&scoped=true"
import script from "./MembersAreaNew.vue?vue&type=script&lang=js"
export * from "./MembersAreaNew.vue?vue&type=script&lang=js"
import style0 from "./MembersAreaNew.scss?vue&type=style&index=0&id=24af3658&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24af3658",
  null
  
)

export default component.exports